import { RoleModel, DefaultServiceResult } from '@/types';

export interface RoleServiceCreateResult extends DefaultServiceResult {
    result: RoleModel;
}
